import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'randomNumber', standalone: false })
export class RandomNumberPipe implements PipeTransform {
    transform(min = 0, max = 1): number {
        return Math.random() * (max - min) + min;
    }
}
